import { DateTime } from 'luxon'

export class UserLoginToken {
	public userId: number
	public token: string
	public createdAt: DateTime
	public expiresAt: DateTime
	public url: string

	constructor(data: {
		userId: number
		token: string
		createdAt: DateTime
		expiresAt: DateTime
		url: string
	}) {
		this.userId = data.userId
		this.token = data.token
		this.createdAt = data.createdAt
		this.expiresAt = data.expiresAt
		this.url = data.url
	}

	static create(data: {
		userId: number
		token: string
		createdAt: DateTime
		expiresAt: DateTime
		url: string
	}): UserLoginToken {
		return new UserLoginToken(data)
	}
}
